import Main from "../views/Main";
import black from '@/components/parent-view'

export const registerRouter = {
  path: "/register/:type",
  name: "register",
  meta: {
    title: "注册"
  },
  component: () =>
    import("@views/register/register.vue")
};
// export const forgetRouter = {
//   path: '/forget',
//   name: 'forget',
//   meta: {
//     title: '忘记密码'
//   },
//   component: () =>
//       import ('@/views/forget.vue')
// };

// export const emptyRouter = {
//   path: '/empty',
//   name: 'empty',
//   meta: {
//     title: '暂无'
//   },
//   component: () =>
//       import ('@/components/empty/empty.vue')
// };


export const otherRouter = {
  path: "/",
  component: Main,
  children: [
    {
      path: "/",
      name: "home",
      meta: {
        name: "首页",
        menuActive: "home",
        navHide: true,
      },
      component: () => import("@views/home/home.vue")
    },
    {
      path: "serviceCenter",
      name: "serviceCenter",
      meta: {
        name: "服务中心",
        menuActive: "serviceCenter",
        navHide: false
      },
      component: () => import("@views/serviceCenter/serviceCenter.vue")
    },
    {
      path: "serviceCenter/detail/:id/:type",
      name: "serviceDetail",
      meta: {
        name: "服务中心详情",
        menuActive: "serviceCenter",
        navHide: true,
        returnBut: true
      },
      component: () => import("@views/serviceCenter/detail.vue")
    },
    {
      path: "activitySchedule",
      name: "activitySchedule",
      meta: {
        name: "服务日程",
        menuActive: "activitySchedule",
        navHide: false
      },
      component: () => import("@views/activitySchedule/activitySchedule.vue")
    },
    {
      path: "myService",
      name: "myService",
      meta: {
        name: "我的服务",
        menuActive: "myService",
        navHide: false
      },
      component: () => import("@views/myService/myService.vue")
    },
    {
      /**type
       * activity 其他活动
       * explain  讲解
       * plan     策划
       * service   服务
       */
      path: "myService/list/:type",
      name: "myServiceList",
      meta: {
        name: "我的服务-列表",
        menuActive: "myService",
        navHide: true,
        returnBut: true
      },
      component: () => import("@views/myService/list.vue")
    },
    {
      path: "myService/detail/:id/:type",
      name: "myServiceDetail",
      meta: {
        name: "我的服务-详情",
        menuActive: "myService",
        navHide: true,
        returnBut: true
      },
      component: () => import("@views/myService/detail.vue")
    },
    {
      path: "myHall",
      name: "myHall",
      meta: {
        name: "我的展厅",
        menuActive: "myHall",
        navHide: false
      },
      component: () => import("@views/myHall/list.vue")
    },
    {
      path: "myHall/detail/:id",
      name: "myHallDetail",
      meta: {
        name: "我的展厅-详情",
        menuActive: "myHall",
        navHide: true,
        returnBut: true
      },
      component: () => import("@views/myHall/detail.vue")
    },
    {
      path: "myApply",
      name: "myApply",
      meta: {
        name: "我的申请",
        menuActive: "myApply",
        navHide: false,
      },
      component: () => import("@views/myApply/list.vue")
    },
    {
      path: "myApply/detail/:id",
      name: "myApplyDetail",
      meta: {
        name: "我的申请-详情",
        menuActive: "myApply",
        navHide: true,
        returnBut: true
      },
      component: () => import("@views/myApply/detail.vue")
    },
    {
      path: "myApply/detail2/:id/:type/:other?",
      name: "myApplyDetail2",
      meta: {
        name: "我的申请-详情2",
        menuActive: "myApply",
        navHide: true,
        returnBut: true
      },
      component: () => import("@views/myService/detail.vue")
    },
    {
      path: "serviceRecord",
      name: "serviceRecord",
      meta: {
        name: "服务记录",
        menuActive: "serviceRecord",
        navHide: false,
      },
      component: () => import("@views/serviceRecord/list.vue")
    },
    {
      path: "serviceRecord/detail/:id",
      name: "serviceRecordDetail",
      meta: {
        name: "服务记录-详情",
        menuActive: "serviceRecord",
        navHide: true,
        returnBut: true
      },
      component: () => import("@views/serviceRecord/detail.vue")
    },
    {
      path: "mySchedule",
      name: "mySchedule",
      meta: {
        name: "我的日程",
        menuActive: "mySchedule",
        navHide: false,
      },
      component: () => import("@views/mySchedule/mySchedule.vue")
    },
    {
      path: "myScore",
      name: "myScore",
      meta: {
        name: "我的积分",
        menuActive: "myScore",
        navHide: false,
      },
      component: () => import("@views/myScore/myScore.vue")
    },
    {
      path: "myScore/detail/:year/:score",
      name: "myScoreDetail",
      meta: {
        name: "我的积分",
        menuActive: "myScore",
        navHide: true,
        returnBut: true
      },
      component: () => import("@views/myScore/scoreDetail.vue")
    },
    {
      path: "rules",
      name: "rules",
      meta: {
        name: "规章条例",
        menuActive: "rules",
        navHide: false,
      },
      component: () => import("@views/rules/list.vue")
    },
    {
      path: "rules/detail/:id",
      name: "rulesDetail",
      meta: {
        name: "规章条例-详情",
        menuActive: "rules",
        navHide: true,
        returnBut: true
      },
      component: () => import("@views/rules/detail.vue")
    },
    {
      path: "help",
      name: "help",
      meta: {
        name: "帮助中心",
        menuActive: "help",
        navHide: false,
      },
      component: () => import("@views/help/list.vue")
    },
    {
      path: "help/detail/:id",
      name: "helpDetail",
      meta: {
        name: "帮助中心",
        menuActive: "help",
        navHide: true,
        returnBut: true
      },
      component: () => import("@views/rules/detail.vue")
    },
    {
      path: "news",
      name: "news",
      meta: {
        name: "我的消息",
        menuActive: "news",
        navHide: false,
      },
      component: () => import("@views/news/list.vue")
    },
    {
      path: "news/detail/:id",
      name: "newsDetail",
      meta: {
        name: "我的消息",
        menuActive: "news",
        navHide: true,
        returnBut: true
      },
      component: () => import("@views/rules/detail.vue")
    },
    {
      path: "info",
      name: "info",
      meta: {
        name: "基本信息",
        menuActive: "info",
        navHide: false,
      },
      component: () => import("@views/info/info.vue")
    },
  ]
}
export const tipRouter = {
  path: "/tip",

  component: black,
  children: [
    {
      path: "rule",
      name: "rule",
      meta: {
        title: "天津博物馆志愿者章程"
      },
      component: () =>
        import("@views/tips/rule.vue")
    },
    {
      path: "tipWarning/:status/:obj?/:refuseReason?",
      name: "tipWarning",
      meta: {
        title: ""
      },
      component: () =>
        import("@views/tips/modal.vue")
    },
  ]
}

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
  // loginRouter,
  registerRouter,
  otherRouter,
  tipRouter
  // forgetRouter,
  // emptyRouter
  // ...appRouter,
  // page500,
  // page403,
  // page404
];
